import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class GetCaptcha extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Competition API
                </h1>
                    <div>
                        <h2 className="main-subheading">
                            allaboutme.pcs.get_captcha</h2>
                        <div className="technical-main-content">
                            <p>
                                Prepares a CAPTCHA image to be used by an image vote. The <em>random</em> string
                            obtained should be stored to used in a subsequent call to <Link to="/technical/competitionapi/addvote">allaboutme.pcs.add_vote</Link>.
                            The CAPTCHA image should be presented to the user using the <em>imageUrl</em>. For
                            more details, see <Link to="/technical/competitionapi/addvote">allaboutme.pcs.add_vote</Link>.
                        </p>
                            <div>
                                <h3>
                                    Arguments</h3>
                                <ul>
                                    <li><b>api_key</b> (Required)
                                    <p>
                                            A valid API key that must be obtained from Thales.</p>
                                    </li>
                                    <li><b>method</b> (Required)
                                    <p>
                                            allaboutme.pcs.get_captcha</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Example response XML payload</h3>
                                <pre>
                                    &lt;Captcha random=&quot;vamamilgofynmihqifnxtahenadmctfurhfvtdog&quot;
                                        imageUrl=&quot;GetCaptcha.aspx?random=vamamilgofynmihqifnxtahenadmctfurhfvtdog&quot; /&gt;
                                </pre>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Error codes</h3>
                                <ul>
                                    <li><b>-1 (General error)</b>
                                    <p>
                                            An internal error ocurred on the server. This is not dependent on the specific method
                                        or parameters passed. If the error persists, contact Thales.</p>
                                    </li>
                                    <li><b>1 (Invalid api_key)</b>
                                    <p>
                                            The <em>api_key</em> passed is not valid or is disabled. Check the key to make sure
                                        it is correct. If so, contact Thales.</p>
                                    </li>
                                    <li><b>2 (Invalid method)</b>
                                    <p>
                                            The method you attempted to call is invalid. Check the <em>method</em> parameter.</p>
                                    </li>
                                    <li><b>3 (No method specified)</b>
                                    <p>
                                            The required <em>method</em> parameter was not informed.</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/competitionapi'>Back</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GetCaptcha;